import { render } from "./classPopover.vue?vue&type=template&id=4f951d4b&scoped=true"
import script from "./classPopover.vue?vue&type=script&lang=js"
export * from "./classPopover.vue?vue&type=script&lang=js"

import "./classPopover.vue?vue&type=style&index=0&id=4f951d4b&lang=scss&scoped=true"

import exportComponent from "D:\\project\\admin-system3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f951d4b"]])

export default __exports__